module.exports = __webpack_public_path__ + "img/kaist_gallery3.d3f38cea.jpg";